module.exports = __webpack_public_path__ + "static/media/GDPR_data_processing_notice.11532a90.pdf";